import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import {
  articleWorkspaceStyles,
  copyArticleStyles,
} from '@texas/resources/theme/styles/entityWorkspace';
import { useTranslation } from 'react-i18next';

export function CopyArticleSectionHeading({
  number,
  title,
  description,
}: {
  number: string;
  title: string;
  description: string;
}) {
  const { t } = useTranslation();
  return (
    <Flex sx={articleWorkspaceStyles.sectionHeader}>
      <Box>
        <Heading sx={articleWorkspaceStyles.sectionTitle}>{title}</Heading>
        <Text sx={articleWorkspaceStyles.sectionDescription}>
          {description}
        </Text>
      </Box>
      <Text sx={copyArticleStyles.stepLabel}>
        {t('article.copy.step', { number })}
      </Text>
    </Flex>
  );
}
